/* eslint-disable sort-keys */
export const GRADEBOOK_ENDPOINTS = {
  FETCH_AGGREGATE_GRADEBOOK_DATA: '/api/viewAggregateGradebook',
  FETCH_AGGREGATE_GRADEBOOK_DETAILS_LIKERT: '/api/viewAggregateGradebookLikertDetail',
  FETCH_AGGREGATE_GRADEBOOK_DETAILS_NORMAL: '/api/viewAggregateGradebookDetail',
  FETCH_AGGREGATE_GRADEBOOK_DETAILS_TYPING: '/api/viewAggregateGradebookTypingDetail',
  FETCH_AGGREGATE_GRADEBOOK_STANDARDS: '/api/viewAggregateGradebookStandards',
  FETCH_ASSIGNMENTS_PROCESSING_COUNT: '/api/getAssignmentsProcessingCount',
  FETCH_GRADEBOOK_ACTIVITY: '/api/viewActivityGradebook',
  FETCH_GRADEBOOK_DETAILS: '/api/viewActivityGradebookDetail',
  SUBMIT_REPORT_REQUEST: '/api/submitReportRequest',
  UPDATE_ACTIVITY_ELEMENT_AGGREGATE_EXCLUSION: '/api/setAggregateElementExclusion',
  UPDATE_ACTIVITY_ELEMENT_EXCLUSION: '/api/setActivityElementExclusion',
  UPDATE_GRADE: '/api/updateActivityInstanceGrade'
};

export const GRADEBOOK_LIKERT_CUT_SCORES = {
  FULL_CREDIT: 5,
  PARTIAL_CREDIT: 3,
  // NO_CREDIT: 0
};

export const GRADEBOOK_CONTEXT = {
  SUMMARY: 'summary',
  DETAILS: 'details',
  LIKERT: 'likert',
  TYPING: 'typing',
  ENGAGEMENT: 'engagement',
  STANDARDS: 'standards'
};

export const GRADEBOOK_SUMMARY_TABLE_CELL = {
  BULK_SELECT: 'bulkSelect',
  ACTIVITY_NUMBER: 'activityNumber',
  START_DATE: 'activityTimezoneStartDate',
  END_DATE: 'activityTimezoneEndDate',
  ASSIGN_TYPE: 'assignEntityTypeId',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  STATUS: 'status',
  STUDENT_STATUS: 'studentStatus',
  SUBMITTED: 'timezoneSubmittedDate',
  GRADE: 'grade',
  AI_GRADING: 'aiGradable',
  INCLUDE_IN_REPORTS: 'includeInReports',
  SCORES_RELEASED: 'scoresReleased',
  STUDENT_REVIEW: 'studentReview',
  FEEDBACK: 'feedback'
};

export const OBSERVATIONAL_GRADER_TOGGLE_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const GRADEBOOK_TABLE_SORT_DEFAULT_ENTRIES = [
  [GRADEBOOK_CONTEXT.SUMMARY, {
    sortColumn: null,
    sortDirection: 'ascending',
  }],
  [GRADEBOOK_CONTEXT.DETAILS, {
    sortColumn: null,
    sortDirection: 'ascending',
    sortScoreIndex: -1
  }],
  [GRADEBOOK_CONTEXT.LIKERT, {
    sortColumn: null,
    sortDirection: 'ascending',
    sortScoreIndex: -1
  }],
  [GRADEBOOK_CONTEXT.TYPING, {
    sortColumn: null,
    sortDirection: 'ascending',
    sortScoreIndex: -1
  }]
];

export const GRADEBOOK_TYPE = {
  AGGREGATE: 'aggregate',
  // NON_AGGREGATE: 'nonAggregate' // defunct
};

export const GRADEBOOK_RESPONSE_CONTENT_STATE = {
  HAS_RESPONSE_CONTENT: 'HasResponseContent',
  NO_RESPONSE_CONTENT: 'NoResponseContent',
};

export const GRADEBOOK_RESPONSE_SUBMITTED_STATE = {
  RESPONSE_NOT_SUBMITTED: 'ResponseNotSubmitted',
  RESPONSE_SUBMITTED: 'ResponseSubmitted',
};

export const GRADEBOOK_SCORE_STATE = {
  AUTO_SCORED: 'AutoScored',
  MANUALLY_OVERRIDEN: 'ManuallyOverridden',
  MANUALLY_SCORED: 'ManuallyScored',
  NOT_SCORED: 'NotScored',
  AI_PENDING: 'AiPending',
  AI_SCORED: 'AiScored',
  AI_OVERIDDEN: 'AiOverridden'
};

export const GRADEBOOK_TABLE_ROWS_MAX_PAGE_SIZE = 100; // max threshold
